import { useParams } from "react-router-dom";
import { Button, Flex } from "@mantine/core";
import { Link } from "react-router-dom";
import QRCodeList from "../../components/QRCodeList/QRCodeList";

const QRCode = () => {
  const { uuid } = useParams();

  return (
    <>
        <Flex
            mih={50}
            gap="md"
            justify="flex-end"
            align="center"
            direction="row"
            wrap="wrap"
            mb={"lg"}
        >
            <Link to={`add`}>
               <Button variant="outline">+ Add Operator Link</Button>
            </Link>
        </Flex>
        <QRCodeList uuid={uuid} />
    </>
  )
};

export default QRCode;